export const initialState = {
  values: {
    harvestId:'',
    priceUnit: '1',
    description: '',
    city: '',
    stateName: '',
    country: '',
    countryId: '',
    stateId: '',
    expectedYield: '',

    file: '',
    gradingRequested: '',
    currency: '',
    discountCapture: '',
    discountAmount: '',
    manPowerRequested: '',
    priceSetByVendor: '',
    publishImmediately: '',
    purchasedDate: '',
    purchasedFrom: '',
    qty: '',
    qtyName: '',
    subSpeciesName: '',
    userId: '',
    certFile:'',
    sectorId: '',

    cityId: '',

    yieldDetailId: '',
    avgWeightSize: '',

    moisturePtg: '',
    moq: '',
    filesList: [],
    isEnsured: true, //
    insurerName: '', //
    insuredType: '',
    videoURL: '',
    insuranceCertificate: '',//
    nutrientValue: '', //
    insuranceDetails: '',//
    multipleFiles:false,//this is to get multiple images input
    digitalCurrAllowed:'',//

    // insured: false,
    productPackSize:"",
    packsPerCartonContainer:"",
    avgLeadTime:"",
    transportMode:"",
    height:"",
    length:"",
    width:"",
    stockLocationCountry:"",
    originCountry:"",
    EAN:"",
    storageTemprature:"",
    offerPrivateLable:"",
    productNameLocalLanguage:"",
    internationalBarcodeAvailable:""
  },
  errors: {
    email: "",
    password: "",
    confirmPassword: "",
    firstName: '',
    description: '',
    lastName: '',
    tradeRole: '',
    currency: '',
    discountCapture:'',
    city: '',
    country: '',
    countryId: '',
    cityId: '',
    stateId: '',
    companyName: '',
    mobile: '',
    expectedYield: '',
    file: '',
    gradingRequested: '',
    manPowerRequested: '',
    priceSetByVendor: '',
    publishImmediately: '',
    purchasedDate: '',
    purchasedFrom: '',
    qty: '',
    qtyName: '',
    subSpeciesName: '',
    userId: '',
    sectorId: '',
    yieldDetailId: '',
    videoURL: '',
    productPackSize:"",
    packsPerCartonContainer:"",
    avgLeadTime:"",
    transportMode:"",
    height:"",
    length:"",
    width:"",
    stockLocationCountry:"",
    originCountry:"",
    EAN:"",
    storageTemprature:"",
    offerPrivateLable:"",
    productNameLocalLanguage:"",
    internationalBarcodeAvailable:""

  },
}
